import React from 'react';
import { InvoiceLineItem } from '../types';
import { formatInvoiceAmount } from '../utils';

interface InvoiceLineItemsProps {
  items: InvoiceLineItem[];
  totalAmount: number;
  currency?: string;
}

export const InvoiceLineItems: React.FC<InvoiceLineItemsProps> = ({
  items,
  totalAmount,
  currency = 'INR',
}) => (
  <div className="invoice-details-modal__line-items">
    <div className="invoice-details-modal__line-items-head">
      <span>Description</span>
      <span>Amount</span>
    </div>

    {items.map((item, index) => (
      <div
        key={`${item.description}-${index}`}
        className={`invoice-details-modal__line-item ${item.muted ? 'invoice-details-modal__line-item--muted' : ''}`}
      >
        <span>{item.description}</span>
        <strong>{formatInvoiceAmount(item.amount, currency)}</strong>
      </div>
    ))}

    <div className="invoice-details-modal__line-items-total">
      <span>Total Amount</span>
      <strong>{formatInvoiceAmount(totalAmount, currency)}</strong>
    </div>
  </div>
);
